var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"font-helvetica font-light",class:_vm.$attrs.animation + ' delay-' + ( _vm.$attrs.k +1 ) +' bg-'+_vm.colourRandom(_vm.$attrs.k),on:{"click":_vm.Answered}},[_c('span',[_vm._v(_vm._s(_vm.$attrs.answer.answer))])])}
var staticRenderFns = []

export { render, staticRenderFns }